const FEATURES = [
  {
    title: 'تأمین‌کنندگان منتخب',
    description: 'دسترسی به تأمین‌کنندگان معتبر',
    image: '/images/featuredsupplier.png',
  },
  {
    title: 'تحویل مطمئن و ارزان',
    description: 'روش‌های ارسال مطمئن',
    image: '/images/delivery.png',
  },
  {
    title: 'پیگیری سفارش',
    description: 'دسترسی برخط از موقعیت سفارش',
    image: '/images/ordertracking.png',
  },
  {
    title: 'پرداخت امن',
    description: 'درگاه‌های پرداخت مطمئن',
    image: '/images/securepayment.png',
  },
  {
    title: 'پشتیبانی تخصصی',
    description: 'مشاوره قبل و بعد از خرید',
    image: '/images/support.png',
  },
  {
    title: 'بازگشت کالا',
    description: 'تا ۷ روز ضمانت بازگشت کالا',
    image: '/images/reverselogistics.png',
  },
];

function FeaturedAdvantages() {
    return (
    <section
      dir="rtl"
      aria-label="مزایای خرید از سازین"
      className="rounded-2xl border border-slate-200 bg-white px-2 py-2 shadow-sm sm:px-3 sm:py-3"
    >
      <div className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto scroll-smooth">
        {FEATURES.map((feature, index) => (
          <article
            key={feature.title}
            className={[
              'flex min-w-[200px] flex-none snap-start items-center gap-2 px-3 py-2',
              'sm:min-w-0 sm:flex-1 sm:justify-center sm:gap-1.5 sm:px-2',
              index !== FEATURES.length - 1 ? 'border-l border-slate-200' : '',
            ].join(' ')}
          >
            <img
              src={feature.image}
              alt=""
              className="h-9 w-9 shrink-0 object-contain sm:h-8 sm:w-8"
            />

            <div className="min-w-0 text-right">
              <h3 className="truncate text-xs font-semibold text-slate-800 sm:text-[11px] lg:text-xs">
                {feature.title}
              </h3>

              <p className="mt-0.5 truncate text-[11px] text-slate-500 sm:text-[10px] lg:text-[11px]">
                {feature.description}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default FeaturedAdvantages;
